import React from 'react';
import I18n from 'i18n-js';
import HomepageMarketingCallout from './homepage_marketing_callout';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

export default function HomepageSell() {
  const backgroundImage = 'https://reverb-res.cloudinary.com/image/upload/v1599599109/Reverb-Sell-Callout_um07t0.jpg';

  return (
    <HomepageMarketingCallout
      imageUrl={backgroundImage}
    >
      <div>
        <h2 className="weight-bold size-160 mobile-size-140 mb-1">
          {I18n.t('discovery.homepage.sellMarketingCallout.title')}
        </h2>
        <ul className="fa-ul mobile-align-left">
          <li className="size-120 mb-1">
            <span className="fa-li">
              <i className="fa fa-check" />
            </span>
            {I18n.t('discovery.homepage.sellMarketingCallout.secureTransactions')}
          </li>
          <li className="size-120 mb-1">
            <span className="fa-li">
              <i className="fa fa-check" />
            </span>
            {I18n.t('discovery.homepage.sellMarketingCallout.listFree')}
          </li>
          <li className="size-120">
            <span className="fa-li">
              <i className="fa fa-check" />
            </span>
            {I18n.t('discovery.homepage.sellMarketingCallout.buyerCommunity')}
          </li>
        </ul>
        <CoreLink
          to="/sell"
          trackName="HomepageSellOnReverb"
          className="button button--primary mt-3"
        >
          {I18n.t('discovery.homepage.sellMarketingCallout.action')}
        </CoreLink>
      </div>
    </HomepageMarketingCallout>
  );
}
